export const blogTranslations = {
  en: {
    // Main blog page
    'blog.title': 'Our Blog',
    'blog.subtitle': 'Stay updated with construction insights, industry trends, and project updates from FMC Construction.',
    
    // Search and filters
    'blog.search.placeholder': 'Search articles...',
    'blog.filters.all': 'All Articles',
    'blog.filters.construction': 'Construction',
    'blog.filters.technology': 'Technology',
    'blog.filters.sustainability': 'Sustainability',
    'blog.filters.industry': 'Industry News',
    'blog.filters.tips': 'Tips & Guides',
    
    // Article categories
    'blog.categories.construction': 'Construction',
    'blog.categories.technology': 'Technology',
    'blog.categories.sustainability': 'Sustainability',
    'blog.categories.industry': 'Industry News',
    'blog.categories.tips': 'Tips & Guides',
    'blog.categories.digital': 'Digital',
    
    // Article meta
    'blog.meta.views': 'views',
    'blog.meta.readTime': 'min read',
    'blog.meta.published': 'Published',
    'blog.meta.author': 'By',
    'blog.meta.category': 'Category',
    
    // Article actions
    'blog.actions.readMore': 'Read More',
    'blog.actions.viewArticle': 'View Article',
    'blog.actions.share': 'Share',
    'blog.actions.bookmark': 'Bookmark',
    
    // No results
    'blog.noResults.title': 'No Articles Found',
    'blog.noResults.message': 'Try adjusting your search criteria or filters to find more articles.',
    'blog.noResults.clearFilters': 'Clear All Filters',
    
    // Pagination
    'blog.pagination.previous': 'Previous',
    'blog.pagination.next': 'Next',
    'blog.pagination.page': 'Page',
    'blog.pagination.of': 'of',
    
    // Featured section
    'blog.featured.title': 'Featured Articles',
    'blog.featured.subtitle': 'Our most popular and insightful content',
    
    // Latest section
    'blog.latest.title': 'Latest Articles',
    'blog.latest.subtitle': 'Fresh insights and updates from our team',
    
    // Popular section
    'blog.popular.title': 'Popular Articles',
    'blog.popular.subtitle': 'Most read and shared content',
    
    // CTA section
    'blog.cta.title': 'Stay Updated',
    'blog.cta.subtitle': 'Subscribe to our newsletter for the latest construction insights and industry updates.',
    'blog.cta.button': 'Subscribe Now',
    
    // Article content examples
    'blog.articles.smartCities.title': 'Smart Cities: The Future of Urban Construction',
    'blog.articles.smartCities.excerpt': 'Exploring how technology is transforming urban development and construction practices.',
    'blog.articles.smartCities.category': 'Technology',
    
    'blog.articles.sustainability.title': 'Sustainable Construction: Building for Tomorrow',
    'blog.articles.sustainability.excerpt': 'Discover eco-friendly construction methods and materials that are shaping the future.',
    'blog.articles.sustainability.category': 'Sustainability',
    
    'blog.articles.projectManagement.title': 'Project Management Excellence: Key Success Factors',
    'blog.articles.projectManagement.excerpt': 'Learn the essential strategies for successful construction project management.',
    'blog.articles.projectManagement.category': 'Tips & Guides',
    
    'blog.articles.buildingCodes.title': 'Understanding Modern Building Codes',
    'blog.articles.buildingCodes.excerpt': 'A comprehensive guide to current building regulations and compliance requirements.',
    'blog.articles.buildingCodes.category': 'Construction',
    
    'blog.articles.industryTrends.title': 'Construction Industry Trends 2024',
    'blog.articles.industryTrends.excerpt': 'Stay ahead with the latest trends and innovations in the construction sector.',
    'blog.articles.industryTrends.category': 'Industry News',
    
    'blog.articles.safetyGuidelines.title': 'Construction Safety: Best Practices Guide',
    'blog.articles.safetyGuidelines.excerpt': 'Essential safety protocols and guidelines for construction professionals.',
    'blog.articles.safetyGuidelines.category': 'Tips & Guides',
    
    'blog.articles.greenBuilding.title': 'Green Building Certification: LEED vs BREEAM',
    'blog.articles.greenBuilding.excerpt': 'Comparing the world\'s leading green building certification systems.',
    'blog.articles.greenBuilding.category': 'Sustainability',
    
    'blog.articles.digitalTransformation.title': 'Digital Transformation in Construction',
    'blog.articles.digitalTransformation.excerpt': 'How digital tools are revolutionizing the construction industry.',
    'blog.articles.digitalTransformation.category': 'Technology',
    
    // Blog card components
    'blog.card.author': 'Author:',
    'blog.card.date': 'Date:',
    'blog.card.readTime': 'Read Time:',
    'blog.card.views': 'Views:',
    'blog.card.excerpt': 'Excerpt:',
    'blog.card.min': 'min',
    'blog.card.featured': 'Featured',
    'blog.card.copyLink': 'Copy Link',
    'blog.card.readMore': 'Read more at:',
    'blog.card.linkCopied': 'Link copied to clipboard! You can now paste it in Instagram.',
    'blog.card.articleNotFound': 'The blog post you\'re looking for doesn\'t exist.',
    'blog.card.backToBlog': 'Back to Blog',
    'blog.card.minRead': 'min read',
    'blog.card.category': 'Category',
    'blog.card.tags': 'Tags',
    'blog.card.share': 'Share',
    'blog.card.bookmark': 'Bookmark',
    'blog.card.like': 'Like',
    'blog.card.comment': 'Comment',
    'blog.card.relatedArticles': 'Related Articles',
    'blog.card.aboutAuthor': 'About the Author',
    'blog.card.fmcAdministrator': 'FMC Administrator',
    'blog.card.fmcAdministratorBio': 'FMC Administrator is responsible for managing and publishing content related to construction industry insights, innovations, and best practices.',
    
    // Blog post content - Smart Cities
    'blog.content.smartCities.title': 'Smart Cities: The Future of Urban Infrastructure',
    'blog.content.smartCities.excerpt': 'Discover how smart city technologies are revolutionizing urban planning and construction, from IoT sensors to intelligent traffic management systems.',
    'blog.content.smartCities.introduction': 'Smart cities represent the future of urban development, integrating advanced technologies to create more efficient, sustainable, and livable environments. As construction companies like FMC Construction, we play a crucial role in building the physical infrastructure that supports these technological innovations.',
    'blog.content.smartCities.keyTechnologies': 'Key Technologies Driving Smart Cities',
    'blog.content.smartCities.foundation': 'The foundation of smart cities lies in several cutting-edge technologies:',
    'blog.content.smartCities.iotSensors': 'Internet of Things (IoT) Sensors',
    'blog.content.smartCities.iotDescription': 'IoT sensors are embedded throughout city infrastructure to collect real-time data on everything from traffic patterns to air quality. These sensors enable:',
    'blog.content.smartCities.iotBenefits': [
      'Real-time monitoring of infrastructure health',
      'Predictive maintenance scheduling',
      'Optimized resource allocation',
      'Enhanced public safety measures'
    ],
    'blog.content.smartCities.trafficManagement': 'Intelligent Traffic Management',
    'blog.content.smartCities.trafficDescription': 'Smart traffic systems use AI and machine learning to optimize traffic flow, reduce congestion, and improve road safety. These systems include:',
    'blog.content.smartCities.trafficFeatures': [
      'Adaptive traffic signal control',
      'Dynamic route optimization',
      'Real-time incident detection',
      'Integrated public transportation management'
    ],
    'blog.content.smartCities.constructionChallenges': 'Construction Challenges in Smart Cities',
    'blog.content.smartCities.challengesDescription': 'Building smart city infrastructure presents unique challenges that require innovative construction approaches:',
    'blog.content.smartCities.infrastructureIntegration': 'Infrastructure Integration',
    'blog.content.smartCities.integrationDescription': 'Smart city projects require seamless integration of traditional construction with digital infrastructure. This involves:',
    'blog.content.smartCities.integrationFeatures': [
      'Installing fiber optic networks during construction',
      'Embedding sensors in building materials',
      'Creating spaces for data centers and communication equipment',
      'Ensuring compatibility with future technology upgrades'
    ],
    'blog.content.smartCities.sustainabilityRequirements': 'Sustainability Requirements',
    'blog.content.smartCities.sustainabilityDescription': 'Smart cities prioritize environmental sustainability, requiring construction companies to:',
    'blog.content.smartCities.sustainabilityFeatures': [
      'Use eco-friendly building materials',
      'Implement energy-efficient construction methods',
      'Design buildings with renewable energy integration',
      'Minimize construction waste and environmental impact'
    ],
    'blog.content.smartCities.fmcRole': 'FMC Construction\'s Role in Smart City Development',
    'blog.content.smartCities.fmcCommitment': 'At FMC Construction, we\'re committed to being at the forefront of smart city development. Our expertise includes:',
    'blog.content.smartCities.smartBuildingConstruction': 'Smart Building Construction',
    'blog.content.smartCities.smartBuildingDescription': 'We specialize in constructing buildings that are designed from the ground up to support smart city technologies. This includes:',
    'blog.content.smartCities.smartBuildingFeatures': [
      'Pre-installed smart building systems',
      'Energy-efficient HVAC systems',
      'Integrated security and access control',
      'Smart lighting and environmental controls'
    ],
    'blog.content.smartCities.infrastructureModernization': 'Infrastructure Modernization',
    'blog.content.smartCities.modernizationDescription': 'We help cities modernize existing infrastructure to support smart technologies:',
    'blog.content.smartCities.modernizationFeatures': [
      'Retrofitting buildings with smart systems',
      'Upgrading transportation infrastructure',
      'Installing smart utility networks',
      'Creating digital connectivity hubs'
    ],
    'blog.content.smartCities.futureTrends': 'Future Trends in Smart City Construction',
    'blog.content.smartCities.trendsDescription': 'The future of smart city construction is exciting, with several emerging trends:',
    'blog.content.smartCities.modularConstruction': 'Modular Construction',
    'blog.content.smartCities.modularDescription': 'Modular construction techniques are becoming increasingly popular for smart city projects due to their efficiency and flexibility.',
    'blog.content.smartCities.3dPrinting': '3D Printing in Construction',
    'blog.content.smartCities.3dPrintingDescription': '3D printing technology is revolutionizing how we build smart city infrastructure, enabling rapid construction of complex structures.',
    'blog.content.smartCities.greenBuildingIntegration': 'Green Building Integration',
    'blog.content.smartCities.greenBuildingDescription': 'Smart cities are increasingly incorporating green building practices, creating sustainable urban environments.',
    'blog.content.smartCities.conclusion': 'Smart cities represent the future of urban living, and construction companies have a vital role to play in making this vision a reality. At FMC Construction, we\'re excited to be part of this transformation, building the infrastructure that will support smarter, more sustainable cities for generations to come.',
    'blog.content.smartCities.finalCommitment': 'As we continue to develop our expertise in smart city construction, we remain committed to innovation, sustainability, and excellence in every project we undertake. The future of urban development is smart, and we\'re building it today.',
    
    // Blog post titles and categories
    'blog.posts.smartCities.title': 'Smart Cities: The Future of Urban Infrastructure',
    'blog.posts.smartCities.excerpt': 'Discover how smart city technologies are revolutionizing urban planning and construction, from IoT sensors to intelligent traffic management systems.',
    'blog.posts.smartCities.category': 'Technology',
    
    'blog.posts.sustainableConstruction.title': 'Sustainable Construction: Building for Tomorrow',
    'blog.posts.sustainableConstruction.excerpt': 'Explore innovative sustainable construction practices that are reducing environmental impact while maintaining cost-effectiveness and quality.',
    'blog.posts.sustainableConstruction.category': 'Sustainability',
    
    'blog.posts.bridgeEngineering.title': 'Modern Bridge Engineering: From Concept to Completion',
    'blog.posts.bridgeEngineering.excerpt': 'An in-depth look at the latest bridge construction techniques, materials, and design principles that are shaping the future of infrastructure.',
    'blog.posts.bridgeEngineering.category': 'Construction',
    
    'blog.posts.prefabricatedConstruction.title': 'The Rise of Prefabricated Construction',
    'blog.posts.prefabricatedConstruction.excerpt': 'How prefabrication is transforming the construction industry, reducing costs, improving quality, and accelerating project delivery.',
    'blog.posts.prefabricatedConstruction.category': 'Industry',
    
    'blog.posts.constructionSafety.title': 'Safety First: Advanced Construction Safety Protocols',
    'blog.posts.constructionSafety.excerpt': 'Essential safety measures and protocols that every construction professional should know to ensure workplace safety and compliance.',
    'blog.posts.constructionSafety.category': 'Tips',
    
    'blog.posts.greenMaterials.title': 'Green Building Materials: Eco-Friendly Alternatives',
    'blog.posts.greenMaterials.excerpt': 'Explore sustainable building materials that are revolutionizing construction while reducing environmental impact and carbon footprint.',
    'blog.posts.greenMaterials.category': 'Sustainability',
    
    'blog.posts.digitalTwins.title': 'Digital Twins in Construction: Virtual Reality Meets Reality',
    'blog.posts.digitalTwins.excerpt': 'How digital twin technology is enabling better project planning, monitoring, and management in modern construction projects.',
    'blog.posts.digitalTwins.category': 'Technology',
    
    'blog.posts.costManagement.title': 'Cost Management Strategies for Large-Scale Projects',
    'blog.posts.costManagement.excerpt': 'Proven strategies and techniques for managing costs effectively in large construction projects while maintaining quality and timelines.',
    'blog.posts.costManagement.category': 'Tips',
    
    'blog.posts.innovativeMaterials.title': 'Innovative Materials in Modern Construction',
    'blog.posts.innovativeMaterials.excerpt': 'Discover cutting-edge construction materials that are revolutionizing the industry, from self-healing concrete to transparent aluminum.',
    'blog.posts.innovativeMaterials.category': 'Technology',
    
    'blog.posts.aiAutomation.title': 'The Future of Construction: AI and Automation',
    'blog.posts.aiAutomation.excerpt': 'How artificial intelligence and automation are transforming construction processes, from design to execution and maintenance.',
    'blog.posts.aiAutomation.category': 'Technology',
    
    'blog.posts.sustainableUrban.title': 'Sustainable Urban Development: Case Studies',
    'blog.posts.sustainableUrban.excerpt': 'Real-world examples of sustainable urban development projects that are setting new standards for environmentally conscious construction.',
    'blog.posts.sustainableUrban.category': 'Sustainability',
    
    'blog.posts.projectManagement.title': 'Construction Project Management Best Practices',
    'blog.posts.projectManagement.excerpt': 'Essential project management techniques and strategies that ensure successful delivery of construction projects on time and within budget.',
    'blog.posts.projectManagement.category': 'Tips',
    
    'blog.posts.bridgeDesign.title': 'Revolutionary Bridge Design: Engineering Marvels',
    'blog.posts.bridgeDesign.excerpt': 'Exploring the most innovative and awe-inspiring bridge designs from around the world, showcasing engineering excellence and creativity.',
    'blog.posts.bridgeDesign.category': 'Construction',
    
    'blog.posts.greenCertification.title': 'Green Building Certification: A Complete Guide',
    'blog.posts.greenCertification.excerpt': 'Comprehensive guide to green building certifications including LEED, BREEAM, and other international standards for sustainable construction.',
    'blog.posts.greenCertification.category': 'Sustainability',
    
    // Blog filters
    'blog.filters.allCategories': 'All Categories',
    
    // Additional missing translations
    'blog.search.label': 'Search',
    'blog.search.placeholder.detailed': 'Search articles, authors, or topics...',
    'blog.category.label': 'Category',
    'blog.date.label': 'Date',
    'blog.results.count': 'article',
    'blog.results.found': 'found',
    'blog.view.photo': 'Photo View',
    'blog.view.grid': 'Grid View',
    'blog.view.list': 'List View',
    'blog.filters.active': 'Active filters:',
    'blog.filters.category': 'Category:',
    'blog.filters.date': 'Date:',
    'blog.filters.search': 'Search:',
    'blog.filters.clearAll': 'Clear all',
    'blog.dateOptions.all': 'All Dates',
    'blog.dateOptions.today': 'Today',
    'blog.dateOptions.week': 'This Week',
    'blog.dateOptions.month': 'This Month',
    'blog.dateOptions.quarter': 'This Quarter',
    'blog.dateOptions.year': 'This Year',
    'blog.buttons.readMore': 'Read More',
    'blog.buttons.shareArticle': 'Share Article',
    'blog.buttons.bookmark': 'Bookmark',
    'blog.buttons.like': 'Like',
    'blog.buttons.comment': 'Comment',
    'blog.stats.author': 'Author:',
    'blog.stats.readTime': 'Read Time:',
    'blog.stats.views': 'Views:',
    'blog.stats.minRead': 'min read',
    'blog.stats.viewsCount': 'views',
    'blog.share.title': 'Share Article',
    'blog.share.whatsapp': 'WhatsApp',
    'blog.share.facebook': 'Facebook',
    'blog.share.twitter': 'Twitter/X',
    'blog.share.instagram': 'Instagram',
    'blog.share.linkedin': 'LinkedIn',
    'blog.tags.more': 'more',
  },
  ar: {
    // Main blog page
    'blog.title': 'أحدث أخبارنا',
    'blog.subtitle': 'ابق على اطلاع برؤى البناء والاتجاهات الصناعية وتحديثات المشاريع من شركة إف إم سي للبناء.',
    
    // Search and filters
    'blog.search.placeholder': 'البحث في المقالات...',
    'blog.filters.all': 'جميع المقالات',
    'blog.filters.construction': 'البناء',
    'blog.filters.technology': 'التكنولوجيا',
    'blog.filters.sustainability': 'الاستدامة',
    'blog.filters.industry': 'أخبار الصناعة',
    'blog.filters.tips': 'نصائح وإرشادات',
    
    // Article categories
    'blog.categories.construction': 'البناء',
    'blog.categories.technology': 'التكنولوجيا',
    'blog.categories.sustainability': 'الاستدامة',
    'blog.categories.industry': 'أخبار الصناعة',
    'blog.categories.tips': 'نصائح وإرشادات',
    'blog.categories.digital': 'رقمي',
    
    // Article meta
    'blog.meta.views': 'مشاهدات',
    'blog.meta.readTime': 'دقائق للقراءة',
    'blog.meta.published': 'نشر في',
    'blog.meta.author': 'بواسطة',
    'blog.meta.category': 'الفئة',
    
    // Article actions
    'blog.actions.readMore': 'اقرأ المزيد',
    'blog.actions.viewArticle': 'عرض المقال',
    'blog.actions.share': 'مشاركة',
    'blog.actions.bookmark': 'حفظ',
    
    // No results
    'blog.noResults.title': 'لم يتم العثور على مقالات',
    'blog.noResults.message': 'حاول تعديل معايير البحث أو المرشحات للعثور على المزيد من المقالات.',
    'blog.noResults.clearFilters': 'مسح جميع المرشحات',
    
    // Pagination
    'blog.pagination.previous': 'السابق',
    'blog.pagination.next': 'التالي',
    'blog.pagination.page': 'الصفحة',
    'blog.pagination.of': 'من',
    
    // Featured section
    'blog.featured.title': 'المقالات المميزة',
    'blog.featured.subtitle': 'أكثر محتوانا شعبية وفائدة',
    
    // Latest section
    'blog.latest.title': 'أحدث المقالات',
    'blog.latest.subtitle': 'رؤى وتحديثات جديدة من فريقنا',
    
    // Popular section
    'blog.popular.title': 'المقالات الشائعة',
    'blog.popular.subtitle': 'أكثر المحتوى قراءة ومشاركة',
    
    // CTA section
    'blog.cta.title': 'ابق على اطلاع',
    'blog.cta.subtitle': 'اشترك في نشرتنا الإخبارية للحصول على أحدث رؤى البناء وتحديثات الصناعة.',
    'blog.cta.button': 'اشترك الآن',
    
    // Article content examples
    'blog.articles.smartCities.title': 'المدن الذكية: مستقبل البناء الحضري',
    'blog.articles.smartCities.excerpt': 'استكشاف كيف تحول التكنولوجيا التطوير الحضري وممارسات البناء.',
    'blog.articles.smartCities.category': 'التكنولوجيا',
    
    'blog.articles.sustainability.title': 'البناء المستدام: البناء للغد',
    'blog.articles.sustainability.excerpt': 'اكتشف طرق ومواد البناء الصديقة للبيئة التي تشكل المستقبل.',
    'blog.articles.sustainability.category': 'الاستدامة',
    
    'blog.articles.projectManagement.title': 'التميز في إدارة المشاريع: عوامل النجاح الرئيسية',
    'blog.articles.projectManagement.excerpt': 'تعلم الاستراتيجيات الأساسية لإدارة مشاريع البناء الناجحة.',
    'blog.articles.projectManagement.category': 'نصائح وإرشادات',
    
    'blog.articles.buildingCodes.title': 'فهم رموز البناء الحديثة',
    'blog.articles.buildingCodes.excerpt': 'دليل شامل للوائح البناء الحالية ومتطلبات الامتثال.',
    'blog.articles.buildingCodes.category': 'البناء',
    
    'blog.articles.industryTrends.title': 'اتجاهات صناعة البناء ٢٠٢٤',
    'blog.articles.industryTrends.excerpt': 'ابق متقدماً مع أحدث الاتجاهات والابتكارات في قطاع البناء.',
    'blog.articles.industryTrends.category': 'أخبار الصناعة',
    
    'blog.articles.safetyGuidelines.title': 'سلامة البناء: دليل أفضل الممارسات',
    'blog.articles.safetyGuidelines.excerpt': 'بروتوكولات وإرشادات السلامة الأساسية للمحترفين في البناء.',
    'blog.articles.safetyGuidelines.category': 'نصائح وإرشادات',
    
    'blog.articles.greenBuilding.title': 'شهادات البناء الأخضر: LEED مقابل BREEAM',
    'blog.articles.greenBuilding.excerpt': 'مقارنة أنظمة شهادات البناء الأخضر الرائدة في العالم.',
    'blog.articles.greenBuilding.category': 'الاستدامة',
    
    'blog.articles.digitalTransformation.title': 'التحول الرقمي في البناء',
    'blog.articles.digitalTransformation.excerpt': 'كيف تحول الأدوات الرقمية صناعة البناء.',
    'blog.articles.digitalTransformation.category': 'التكنولوجيا',
    
    // Blog card components
    'blog.card.author': 'المؤلف:',
    'blog.card.date': 'التاريخ:',
    'blog.card.readTime': 'وقت القراءة:',
    'blog.card.views': 'المشاهدات:',
    'blog.card.excerpt': 'المقتطف:',
    'blog.card.min': 'دقيقة',
    'blog.card.featured': 'مميز',
    'blog.card.copyLink': 'نسخ الرابط',
    'blog.card.readMore': 'اقرأ المزيد في:',
    'blog.card.linkCopied': 'تم نسخ الرابط! يمكنك الآن لصقه في إنستغرام.',
    'blog.card.articleNotFound': 'المقال الذي تبحث عنه غير موجود.',
    'blog.card.backToBlog': 'العودة إلى المدونة',
    'blog.card.minRead': 'دقائق للقراءة',
    'blog.card.category': 'الفئة',
    'blog.card.tags': 'العلامات',
    'blog.card.share': 'مشاركة',
    'blog.card.bookmark': 'حفظ',
    'blog.card.like': 'إعجاب',
    'blog.card.comment': 'تعليق',
    'blog.card.relatedArticles': 'مقالات ذات صلة',
    'blog.card.aboutAuthor': 'حول المؤلف',
    'blog.card.fmcAdministrator': 'مدير إف إم سي',
    'blog.card.fmcAdministratorBio': 'مدير إف إم سي مسؤول عن إدارة ونشر المحتوى المتعلق برؤى صناعة البناء والابتكارات وأفضل الممارسات.',
    
    // Blog post content - Smart Cities (Arabic)
    'blog.content.smartCities.title': 'المدن الذكية: مستقبل البنية التحتية الحضرية',
    'blog.content.smartCities.excerpt': 'اكتشف كيف تحول تقنيات المدن الذكية التخطيط الحضري والبناء، من أجهزة استشعار إنترنت الأشياء إلى أنظمة إدارة المرور الذكية.',
    'blog.content.smartCities.introduction': 'تمثل المدن الذكية مستقبل التطوير الحضري، حيث تدمج التقنيات المتقدمة لخلق بيئات أكثر كفاءة واستدامة وملاءمة للعيش. كشركات بناء مثل شركة إف إم سي للبناء، نلعب دوراً حاسماً في بناء البنية التحتية المادية التي تدعم هذه الابتكارات التكنولوجية.',
    'blog.content.smartCities.keyTechnologies': 'التقنيات الرئيسية التي تقود المدن الذكية',
    'blog.content.smartCities.foundation': 'تستند المدن الذكية إلى عدة تقنيات متطورة:',
    'blog.content.smartCities.iotSensors': 'أجهزة استشعار إنترنت الأشياء (IoT)',
    'blog.content.smartCities.iotDescription': 'أجهزة استشعار إنترنت الأشياء مدمجة في جميع أنحاء البنية التحتية للمدينة لجمع البيانات في الوقت الفعلي حول كل شيء من أنماط المرور إلى جودة الهواء. هذه الأجهزة تمكن من:',
    'blog.content.smartCities.iotBenefits': [
      'مراقبة صحة البنية التحتية في الوقت الفعلي',
      'جدولة الصيانة التنبؤية',
      'تخصيص الموارد المحسنة',
      'تعزيز تدابير السلامة العامة'
    ],
    'blog.content.smartCities.trafficManagement': 'إدارة المرور الذكية',
    'blog.content.smartCities.trafficDescription': 'أنظمة المرور الذكية تستخدم الذكاء الاصطناعي والتعلم الآلي لتحسين تدفق المرور وتقليل الازدحام وتحسين سلامة الطرق. تشمل هذه الأنظمة:',
    'blog.content.smartCities.trafficFeatures': [
      'التحكم في إشارات المرور التكيفية',
      'تحسين المسار الديناميكي',
      'كشف الحوادث في الوقت الفعلي',
      'إدارة النقل العام المتكاملة'
    ],
    'blog.content.smartCities.constructionChallenges': 'تحديات البناء في المدن الذكية',
    'blog.content.smartCities.challengesDescription': 'بناء البنية التحتية للمدن الذكية يطرح تحديات فريدة تتطلب نهج بناء مبتكرة:',
    'blog.content.smartCities.infrastructureIntegration': 'تكامل البنية التحتية',
    'blog.content.smartCities.integrationDescription': 'مشاريع المدن الذكية تتطلب تكاملاً سلساً بين البناء التقليدي والبنية التحتية الرقمية. يتضمن هذا:',
    'blog.content.smartCities.integrationFeatures': [
      'تركيب شبكات الألياف البصرية أثناء البناء',
      'دمج أجهزة الاستشعار في مواد البناء',
      'إنشاء مساحات لمراكز البيانات ومعدات الاتصالات',
      'ضمان التوافق مع ترقيات التكنولوجيا المستقبلية'
    ],
    'blog.content.smartCities.sustainabilityRequirements': 'متطلبات الاستدامة',
    'blog.content.smartCities.sustainabilityDescription': 'المدن الذكية تعطي الأولوية للاستدامة البيئية، مما يتطلب من شركات البناء:',
    'blog.content.smartCities.sustainabilityFeatures': [
      'استخدام مواد بناء صديقة للبيئة',
      'تنفيذ طرق بناء موفرة للطاقة',
      'تصميم المباني مع تكامل الطاقة المتجددة',
      'تقليل نفايات البناء والتأثير البيئي'
    ],
    'blog.content.smartCities.fmcRole': 'دور شركة إف إم سي للبناء في تطوير المدن الذكية',
    'blog.content.smartCities.fmcCommitment': 'في شركة إف إم سي للبناء، نحن ملتزمون بأن نكون في طليعة تطوير المدن الذكية. خبرتنا تشمل:',
    'blog.content.smartCities.smartBuildingConstruction': 'بناء المباني الذكية',
    'blog.content.smartCities.smartBuildingDescription': 'نتخصص في بناء المباني المصممة من الأساس لدعم تقنيات المدن الذكية. يشمل هذا:',
    'blog.content.smartCities.smartBuildingFeatures': [
      'أنظمة المباني الذكية المثبتة مسبقاً',
      'أنظمة التدفئة والتهوية وتكييف الهواء الموفرة للطاقة',
      'الأمان المتكامل والتحكم في الوصول',
      'الإضاءة الذكية والتحكم البيئي'
    ],
    'blog.content.smartCities.infrastructureModernization': 'تحديث البنية التحتية',
    'blog.content.smartCities.modernizationDescription': 'نساعد المدن في تحديث البنية التحتية الموجودة لدعم التقنيات الذكية:',
    'blog.content.smartCities.modernizationFeatures': [
      'تحديث المباني بأنظمة ذكية',
      'ترقية البنية التحتية للنقل',
      'تركيب شبكات المرافق الذكية',
      'إنشاء مراكز الاتصال الرقمي'
    ],
    'blog.content.smartCities.futureTrends': 'الاتجاهات المستقبلية في بناء المدن الذكية',
    'blog.content.smartCities.trendsDescription': 'مستقبل بناء المدن الذكية مثير، مع عدة اتجاهات ناشئة:',
    'blog.content.smartCities.modularConstruction': 'البناء المعياري',
    'blog.content.smartCities.modularDescription': 'تقنيات البناء المعياري تصبح شائعة بشكل متزايد لمشاريع المدن الذكية بسبب كفاءتها ومرونتها.',
    'blog.content.smartCities.3dPrinting': 'الطباعة ثلاثية الأبعاد في البناء',
    'blog.content.smartCities.3dPrintingDescription': 'تكنولوجيا الطباعة ثلاثية الأبعاد تحدث ثورة في كيفية بناء البنية التحتية للمدن الذكية، مما يتيح البناء السريع للهياكل المعقدة.',
    'blog.content.smartCities.greenBuildingIntegration': 'تكامل البناء الأخضر',
    'blog.content.smartCities.greenBuildingDescription': 'المدن الذكية تدمج بشكل متزايد ممارسات البناء الأخضر، مما يخلق بيئات حضرية مستدامة.',
    'blog.content.smartCities.conclusion': 'تمثل المدن الذكية مستقبل الحياة الحضرية، وشركات البناء لها دور حيوي في جعل هذه الرؤية حقيقة. في شركة إف إم سي للبناء، نحن متحمسون لأن نكون جزءاً من هذا التحول، نبني البنية التحتية التي ستدعم مدناً أذكى وأكثر استدامة للأجيال القادمة.',
    'blog.content.smartCities.finalCommitment': 'بينما نواصل تطوير خبرتنا في بناء المدن الذكية، نحن ملتزمون بالابتكار والاستدامة والتميز في كل مشروع نقوم به. مستقبل التطوير الحضري ذكي، ونحن نبنيها اليوم.',
    
    // Blog post titles and categories (Arabic)
    'blog.posts.smartCities.title': 'المدن الذكية: مستقبل البنية التحتية الحضرية',
    'blog.posts.smartCities.excerpt': 'اكتشف كيف تحول تقنيات المدن الذكية التخطيط الحضري والبناء، من أجهزة استشعار إنترنت الأشياء إلى أنظمة إدارة المرور الذكية.',
    'blog.posts.smartCities.category': 'التكنولوجيا',
    
    'blog.posts.sustainableConstruction.title': 'البناء المستدام: بناء الغد',
    'blog.posts.sustainableConstruction.excerpt': 'استكشف ممارسات البناء المستدام المبتكرة التي تقلل من التأثير البيئي مع الحفاظ على فعالية التكلفة والجودة.',
    'blog.posts.sustainableConstruction.category': 'الاستدامة',
    
    'blog.posts.bridgeEngineering.title': 'هندسة الجسور الحديثة: من المفهوم إلى الإنجاز',
    'blog.posts.bridgeEngineering.excerpt': 'نظرة متعمقة على أحدث تقنيات بناء الجسور والمواد ومبادئ التصميم التي تشكل مستقبل البنية التحتية.',
    'blog.posts.bridgeEngineering.category': 'البناء',
    
    'blog.posts.prefabricatedConstruction.title': 'صعود البناء الجاهز',
    'blog.posts.prefabricatedConstruction.excerpt': 'كيف يحول البناء الجاهز صناعة البناء، ويقلل التكاليف، ويحسن الجودة، ويسرع تسليم المشاريع.',
    'blog.posts.prefabricatedConstruction.category': 'الصناعة',
    
    'blog.posts.constructionSafety.title': 'السلامة أولاً: بروتوكولات السلامة المتقدمة في البناء',
    'blog.posts.constructionSafety.excerpt': 'تدابير السلامة والبروتوكولات الأساسية التي يجب أن يعرفها كل محترف في البناء لضمان سلامة مكان العمل والامتثال.',
    'blog.posts.constructionSafety.category': 'نصائح',
    
    'blog.posts.greenMaterials.title': 'مواد البناء الخضراء: بدائل صديقة للبيئة',
    'blog.posts.greenMaterials.excerpt': 'استكشف مواد البناء المستدامة التي تحدث ثورة في البناء مع تقليل التأثير البيئي والبصمة الكربونية.',
    'blog.posts.greenMaterials.category': 'الاستدامة',
    
    'blog.posts.digitalTwins.title': 'التوائم الرقمية في البناء: الواقع الافتراضي يلتقي بالواقع',
    'blog.posts.digitalTwins.excerpt': 'كيف تمكن تكنولوجيا التوائم الرقمية من تخطيط ومراقبة وإدارة أفضل للمشاريع في مشاريع البناء الحديثة.',
    'blog.posts.digitalTwins.category': 'التكنولوجيا',
    
    'blog.posts.costManagement.title': 'استراتيجيات إدارة التكاليف للمشاريع واسعة النطاق',
    'blog.posts.costManagement.excerpt': 'استراتيجيات وتقنيات مثبتة لإدارة التكاليف بفعالية في مشاريع البناء الكبيرة مع الحفاظ على الجودة والجداول الزمنية.',
    'blog.posts.costManagement.category': 'نصائح',
    
    'blog.posts.innovativeMaterials.title': 'المواد المبتكرة في البناء الحديث',
    'blog.posts.innovativeMaterials.excerpt': 'اكتشف مواد البناء المتطورة التي تحدث ثورة في الصناعة، من الخرسانة ذاتية الشفاء إلى الألومنيوم الشفاف.',
    'blog.posts.innovativeMaterials.category': 'التكنولوجيا',
    
    'blog.posts.aiAutomation.title': 'مستقبل البناء: الذكاء الاصطناعي والأتمتة',
    'blog.posts.aiAutomation.excerpt': 'كيف يحول الذكاء الاصطناعي والأتمتة عمليات البناء، من التصميم إلى التنفيذ والصيانة.',
    'blog.posts.aiAutomation.category': 'التكنولوجيا',
    
    'blog.posts.sustainableUrban.title': 'التطوير الحضري المستدام: دراسات حالة',
    'blog.posts.sustainableUrban.excerpt': 'أمثلة من العالم الحقيقي لمشاريع التطوير الحضري المستدام التي تحدد معايير جديدة للبناء الواعي بيئياً.',
    'blog.posts.sustainableUrban.category': 'الاستدامة',
    
    'blog.posts.projectManagement.title': 'أفضل ممارسات إدارة مشاريع البناء',
    'blog.posts.projectManagement.excerpt': 'تقنيات واستراتيجيات إدارة المشاريع الأساسية التي تضمن التسليم الناجح لمشاريع البناء في الوقت المحدد وفي حدود الميزانية.',
    'blog.posts.projectManagement.category': 'نصائح',
    
    'blog.posts.bridgeDesign.title': 'تصميم الجسور الثوري: عجائب الهندسة',
    'blog.posts.bridgeDesign.excerpt': 'استكشاف أكثر تصاميم الجسور ابتكاراً ومذهلة من حول العالم، مع إبراز التميز الهندسي والإبداع.',
    'blog.posts.bridgeDesign.category': 'البناء',
    
    'blog.posts.greenCertification.title': 'شهادات البناء الأخضر: دليل شامل',
    'blog.posts.greenCertification.excerpt': 'دليل شامل لشهادات البناء الأخضر بما في ذلك LEED و BREEAM ومعايير دولية أخرى للبناء المستدام.',
    'blog.posts.greenCertification.category': 'الاستدامة',
    
    // Blog filters (Arabic)
    'blog.filters.allCategories': 'جميع الفئات',
    
    // Additional missing translations
    'blog.search.label': 'البحث',
    'blog.search.placeholder.detailed': 'البحث في المقالات والمؤلفين والمواضيع...',
    'blog.category.label': 'الفئة',
    'blog.date.label': 'التاريخ',
    'blog.results.count': 'مقال',
    'blog.results.countPlural': 'مقال',
    'blog.results.found': 'تم العثور عليها',
    'blog.view.photo': 'عرض الصور',
    'blog.view.grid': 'عرض الشبكة',
    'blog.view.list': 'عرض القائمة',
    'blog.filters.active': 'المرشحات النشطة:',
    'blog.filters.category': 'الفئة:',
    'blog.filters.date': 'التاريخ:',
    'blog.filters.search': 'البحث:',
    'blog.filters.clearAll': 'مسح الكل',
    'blog.dateOptions.all': 'جميع التواريخ',
    'blog.dateOptions.today': 'اليوم',
    'blog.dateOptions.week': 'هذا الأسبوع',
    'blog.dateOptions.month': 'هذا الشهر',
    'blog.dateOptions.quarter': 'هذا الربع',
    'blog.dateOptions.year': 'هذا العام',
    'blog.buttons.readMore': 'اقرأ المزيد',
    'blog.buttons.shareArticle': 'مشاركة المقال',
    'blog.buttons.bookmark': 'حفظ',
    'blog.buttons.like': 'إعجاب',
    'blog.buttons.comment': 'تعليق',
    'blog.stats.author': 'المؤلف:',
    'blog.stats.readTime': 'وقت القراءة:',
    'blog.stats.views': 'المشاهدات:',
    'blog.stats.minRead': 'دقائق للقراءة',
    'blog.stats.viewsCount': 'مشاهدات',
    'blog.share.title': 'مشاركة المقال',
    'blog.share.whatsapp': 'واتساب',
    'blog.share.facebook': 'فيسبوك',
    'blog.share.twitter': 'تويتر/إكس',
    'blog.share.instagram': 'إنستغرام',
    'blog.share.linkedin': 'لينكد إن',
    'blog.tags.more': 'المزيد',
  }
};
